import { useState } from "react";
import { faqList } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-primary-700 bg-primary-100 px-3 py-1 rounded-full">
              <i className="ri-question-line"></i>
              <span>常见问题</span>
            </div>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
              关于联系黑料官方，你可能想问
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">
              没找到答案？直接发邮件给官方客服，会有专人跟进回复。
            </p>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-2 border border-primary-300 text-primary-700 hover:bg-primary-100 text-sm font-medium px-4 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-mail-send-line"></i>
              <span>联系客服</span>
            </a>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqList.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className={`rounded-lg border transition-colors ${
                    isOpen ? "border-primary-200 bg-primary-50" : "border-background-200/80 bg-background-100"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
                  >
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950">
                      {item.q}
                    </h3>
                    <span
                      className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center text-lg transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="px-5 md:px-6 pb-5 text-xs md:text-sm leading-relaxed text-foreground-700">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}